import { makeStyles, Spinner } from "@fluentui/react-components";
import { useStore } from "../state/store";

const useStyles = makeStyles({
  overlay: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 1000,
  },
});

/** Full-screen spinner driven by the global `loading` flag. */
export function LoadingOverlay(): JSX.Element | null {
  const styles = useStyles();
  const loading = useStore((s) => s.loading);
  if (!loading) return null;
  return (
    <div className={styles.overlay} aria-live="polite" aria-busy="true">
      <Spinner size="large" appearance="primary" />
    </div>
  );
}
